
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexDkCbQPDA8tMeta } from "/codebuild/output/src1173175546/src/pages/index.vue?macro=true";
import { default as aboutobdODS6yryMeta } from "/codebuild/output/src1173175546/src/pages/about.vue?macro=true";
import { default as data1fn1mByINdMeta } from "/codebuild/output/src1173175546/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptiongdATUnTgftMeta } from "/codebuild/output/src1173175546/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioning9iZ7e8xKLyMeta } from "/codebuild/output/src1173175546/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyEQQ06ipHQ5Meta } from "/codebuild/output/src1173175546/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45account1lxOH6CKEcMeta } from "/codebuild/output/src1173175546/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statue3QKyPNe9wyMeta } from "/codebuild/output/src1173175546/src/pages/account-settings/statue.vue?macro=true";
import { default as supportliJ8WaHsr9Meta } from "/codebuild/output/src1173175546/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settings8CG5lpdZs6Meta } from "/codebuild/output/src1173175546/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountnL7qDlN7lqMeta } from "/codebuild/output/src1173175546/src/pages/activate-account.vue?macro=true";
import { default as companyQYwSZ1G78aMeta } from "/codebuild/output/src1173175546/src/pages/admin/company.vue?macro=true";
import { default as consentsKrdnyhNtWLMeta } from "/codebuild/output/src1173175546/src/pages/admin/consents.vue?macro=true";
import { default as leadswi63KdJBXuMeta } from "/codebuild/output/src1173175546/src/pages/admin/leads.vue?macro=true";
import { default as paymentsgxQYPUurIjMeta } from "/codebuild/output/src1173175546/src/pages/admin/payments.vue?macro=true";
import { default as premiumwtHTKsmG6CMeta } from "/codebuild/output/src1173175546/src/pages/admin/premium.vue?macro=true";
import { default as profiles2uHIAZfuyYMeta } from "/codebuild/output/src1173175546/src/pages/admin/profiles.vue?macro=true";
import { default as usersKj41HcUhi5Meta } from "/codebuild/output/src1173175546/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordbvnStZKvUXMeta } from "/codebuild/output/src1173175546/src/pages/change-password.vue?macro=true";
import { default as _91id_93mHToSYkYKTMeta } from "/codebuild/output/src1173175546/src/pages/chat/[id].vue?macro=true";
import { default as ai_46clientuDOYuDRnAfMeta } from "/codebuild/output/src1173175546/src/pages/chat/ai.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src1173175546/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexeVn99ryR54Meta } from "/codebuild/output/src1173175546/src/pages/chat/index.vue?macro=true";
import { default as _91id_93uvwyKlqxa5Meta } from "/codebuild/output/src1173175546/src/pages/client/profile/[id].vue?macro=true";
import { default as indexp7MDv4O53KMeta } from "/codebuild/output/src1173175546/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93emFjOqBWlUMeta } from "/codebuild/output/src1173175546/src/pages/contacts/[id].vue?macro=true";
import { default as index9DwkfTW3jRMeta } from "/codebuild/output/src1173175546/src/pages/contacts/index.vue?macro=true";
import { default as contactsOPL6P4VUuJMeta } from "/codebuild/output/src1173175546/src/pages/contacts.vue?macro=true";
import { default as _91userId_93EydPZP2uvfMeta } from "/codebuild/output/src1173175546/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexdbgJ1yGphdMeta } from "/codebuild/output/src1173175546/src/pages/login/index.vue?macro=true";
import { default as register_45successF4284qA093Meta } from "/codebuild/output/src1173175546/src/pages/login/register-success.vue?macro=true";
import { default as loginNDIZUcRCFXMeta } from "/codebuild/output/src1173175546/src/pages/login.vue?macro=true";
import { default as logoutGXgPNmAZKoMeta } from "/codebuild/output/src1173175546/src/pages/logout.vue?macro=true";
import { default as consentsYF81pDXjv4Meta } from "/codebuild/output/src1173175546/src/pages/manager/consents.vue?macro=true";
import { default as integrationstMWeHn1aDKMeta } from "/codebuild/output/src1173175546/src/pages/manager/integrations.vue?macro=true";
import { default as leadsCXnn6uBOEHMeta } from "/codebuild/output/src1173175546/src/pages/manager/leads.vue?macro=true";
import { default as paymentsgPrPTw66IsMeta } from "/codebuild/output/src1173175546/src/pages/manager/payments.vue?macro=true";
import { default as profileR7nPEgYjpgMeta } from "/codebuild/output/src1173175546/src/pages/manager/profile.vue?macro=true";
import { default as teamAyb7A5Yig7Meta } from "/codebuild/output/src1173175546/src/pages/manager/team.vue?macro=true";
import { default as indexjyW9ba1ETAMeta } from "/codebuild/output/src1173175546/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientKSOb2ZRavlMeta } from "/codebuild/output/src1173175546/src/pages/marketplace/search/[catId].client.vue?macro=true";
import { default as marketplaceZLGiY1HCiNMeta } from "/codebuild/output/src1173175546/src/pages/marketplace.vue?macro=true";
import { default as subscribenVNPf3xE8RMeta } from "/codebuild/output/src1173175546/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46client5HPdCEywpwMeta } from "/codebuild/output/src1173175546/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientsoTLWORh1XMeta } from "/codebuild/output/src1173175546/src/pages/orders/my.client.vue?macro=true";
import { default as privacyL5jYM2bcWKMeta } from "/codebuild/output/src1173175546/src/pages/privacy.vue?macro=true";
import { default as indexscqOXs65YxMeta } from "/codebuild/output/src1173175546/src/pages/recover/index.vue?macro=true";
import { default as successCjyv39qe86Meta } from "/codebuild/output/src1173175546/src/pages/register/success.vue?macro=true";
import { default as _91id_937uid9VMIovMeta } from "/codebuild/output/src1173175546/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexQq74nuP3JTMeta } from "/codebuild/output/src1173175546/src/pages/sales/profile/index.vue?macro=true";
import { default as statueEt65usa9goMeta } from "/codebuild/output/src1173175546/src/pages/statue.vue?macro=true";
import { default as successRAgJw1KFQYMeta } from "/codebuild/output/src1173175546/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubamwZMBtpQkMeta } from "/codebuild/output/src1173175546/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubamwZMBtpQk } from "/codebuild/output/src1173175546/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexDkCbQPDA8tMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutobdODS6yryMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutobdODS6yryMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settings8CG5lpdZs6Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settings8CG5lpdZs6Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src1173175546/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountnL7qDlN7lqMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountnL7qDlN7lqMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyQYwSZ1G78aMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyQYwSZ1G78aMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentsKrdnyhNtWLMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentsKrdnyhNtWLMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadswi63KdJBXuMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadswi63KdJBXuMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsgxQYPUurIjMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsgxQYPUurIjMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumwtHTKsmG6CMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumwtHTKsmG6CMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profiles2uHIAZfuyYMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profiles2uHIAZfuyYMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersKj41HcUhi5Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersKj41HcUhi5Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordbvnStZKvUXMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordbvnStZKvUXMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/change-password.vue")
  },
  {
    name: "chat-id___en",
    path: "/en/chat/:id()",
    meta: _91id_93mHToSYkYKTMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/chat/[id].vue")
  },
  {
    name: "chat-id___pl",
    path: "/pl/chat/:id()",
    meta: _91id_93mHToSYkYKTMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "/en/chat/ai",
    meta: ai_46clientuDOYuDRnAfMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1173175546/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat-ai___pl",
    path: "/pl/chat/ai",
    meta: ai_46clientuDOYuDRnAfMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1173175546/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat___en",
    path: "/en/chat",
    meta: indexeVn99ryR54Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    meta: indexeVn99ryR54Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/chat/index.vue")
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93uvwyKlqxa5Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93uvwyKlqxa5Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexp7MDv4O53KMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexp7MDv4O53KMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/client/profile/index.vue")
  },
  {
    name: contactsOPL6P4VUuJMeta?.name,
    path: "/en/contacts",
    meta: contactsOPL6P4VUuJMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93emFjOqBWlUMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: index9DwkfTW3jRMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsOPL6P4VUuJMeta?.name,
    path: "/pl/contacts",
    meta: contactsOPL6P4VUuJMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93emFjOqBWlUMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: index9DwkfTW3jRMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93EydPZP2uvfMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93EydPZP2uvfMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexDkCbQPDA8tMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexDkCbQPDA8tMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/index.vue")
  },
  {
    name: loginNDIZUcRCFXMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src1173175546/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexdbgJ1yGphdMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successF4284qA093Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginNDIZUcRCFXMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src1173175546/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexdbgJ1yGphdMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successF4284qA093Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutGXgPNmAZKoMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutGXgPNmAZKoMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsYF81pDXjv4Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsYF81pDXjv4Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationstMWeHn1aDKMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationstMWeHn1aDKMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsCXnn6uBOEHMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsCXnn6uBOEHMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsgPrPTw66IsMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsgPrPTw66IsMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileR7nPEgYjpgMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileR7nPEgYjpgMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamAyb7A5Yig7Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamAyb7A5Yig7Meta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/manager/team.vue")
  },
  {
    name: marketplaceZLGiY1HCiNMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceZLGiY1HCiNMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src1173175546/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientKSOb2ZRavlMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1173175546/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceZLGiY1HCiNMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceZLGiY1HCiNMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src1173175546/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientKSOb2ZRavlMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1173175546/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribenVNPf3xE8RMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribenVNPf3xE8RMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46client5HPdCEywpwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1173175546/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46client5HPdCEywpwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1173175546/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientsoTLWORh1XMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1173175546/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientsoTLWORh1XMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1173175546/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyL5jYM2bcWKMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyL5jYM2bcWKMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexscqOXs65YxMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexscqOXs65YxMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src1173175546/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src1173175546/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_937uid9VMIovMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_937uid9VMIovMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexQq74nuP3JTMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexQq74nuP3JTMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueEt65usa9goMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueEt65usa9goMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successRAgJw1KFQYMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successRAgJw1KFQYMeta || {},
    component: () => import("/codebuild/output/src1173175546/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubamwZMBtpQkMeta?.name,
    path: "/old-page",
    component: component_45stubamwZMBtpQk
  }
]